import { subscriptionActionTypes } from './subscription.types';

export const setCurrentSubscription = (subscription) => ({
	type: subscriptionActionTypes.SET_CURRENT_SUBSCRIPTION,
	payload: subscription,
});
